export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = BACKEND_URL + "/api/";
export const IMAGE_URL = BACKEND_URL + "/photos/";
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const PARKPASS_BACKEND_URL = process.env.REACT_APP_PARKPASS_BACKEND_URL;
